export const ShareRequestTableHeaders = {
    bill_key: {
        value: "Reference #",
        minWidth: 120,
    },
    service_date: {
        value: "Date Of Service",
        minWidth: 200,
    },
    memberName: {
        value: "Member Name",
        minWidth: 150,
    },
    paid_provider_name: {
        value: "Provider",
        minWidth: 150,
    },
    charged_amount: {
        value: "Charged Amount",
        minWidth: 150,
    },
    paid_amount: {
        value: "Paid Amount",
        minWidth: 120,
    },
    status: {
        value: "Status",
        minWidth: 200,
    },
};
export const SubShareRequestTableHeaders = {
    date_paid: {
        value: "Paid Date",
        minWidth: 100,
    },
    repricing_amount: {
        value: "Repriced Amount",
        minWidth: 120,
    },
    mpv: {
        value: "Visit Fees (MPV)",
        minWidth: 120,
    },
    mcp: {
        value: "Member Commitment Portion (MCP)",
        minWidth: 150,
    },
    shareable_amount: {
        value: "Shareable Amount",
        minWidth: 150,
    },
};
export const headCells = [
    { id: "arrow", numeric: true, disablePadding: false, label: "" },
    {
        id: "bill_key",
        numeric: true,
        disablePadding: false,
        label: "Reference #",
    },
    {
        id: "service_date",
        numeric: true,
        disablePadding: false,
        label: "Date Of Service",
    },
    { id: "first_name", numeric: false, disablePadding: false, label: "Member" },
    {
        id: "paid_provider_name",
        numeric: false,
        disablePadding: false,
        label: "Provider",
    },
    {
        id: "charged_amount",
        numeric: true,
        disablePadding: false,
        label: "Charged Amount",
    },
    {
        id: "paid_amount",
        numeric: true,
        disablePadding: false,
        label: "Paid Amount",
    },
    { id: "status", numeric: true, disablePadding: false, label: " Status" },
];
export const UHF_BRAND = {
    shareRequestTableHeaders: {
        bill_key: {
            value: "Expense Number",
            minWidth: 120,
        },
        memberName: {
            value: "Member",
            minWidth: 150,
        },
        service_date: {
            value: "Date Of Service",
            minWidth: 200,
        },
        paid_provider_name: {
            value: "provider",
            minWidth: 120,
        },
        charged_amount: {
            value: "Charged",
            minWidth: 150,
        },
        status: {
            value: "Status",
            minWidth: 200,
        },
    },
    headCells: [
        { id: "arrow", numeric: true, disablePadding: false, label: "" },
        { id: "bill_key", numeric: true, disablePadding: false, label: "Expense Number" },
        { id: "memberName", numeric: false, disablePadding: false, label: "Member" },
        { id: "service_date", numeric: false, disablePadding: false, label: "Date Of Service" },
        { id: "paid_provider_name", numeric: false, disablePadding: false, label: "Provider" },
        { id: "charged_amount", numeric: false, disablePadding: false, label: "Charged" },
        { id: "status", numeric: false, disablePadding: false, label: " Status" },
    ],
    SubShareRequestTableHeaders: {
        charged_amount: {
            value: "Billed Charges",
            minWidth: 100,
        },
        ineligible_amount: {
            value: "Ineligible for Sharing",
            minWidth: 120,
        },
        repricing_amount: {
            value: "Discount to Billed Charges",
            minWidth: 120,
        },
        eligible_for_sharing: {
            value: "Eligible for Sharing",
            minWidth: 150,
        },
        sharing_percentage: {
            value: "Non-Shareable Amount",
            minWidth: 150,
        },
        consultation_fee: {
            value: "Consultation Fee",
            minWidth: 150,
        },
        member_responsibility: {
            value: "Member Responsibility",
            minWidth: 150,
        },
    }
};
